const CloseFilled = ({ color = '#8C98AB' }: { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill={color}
      d="M12 1C5.917 1 1 5.917 1 12s4.917 11 11 11 11-4.917 11-11S18.083 1 12 1Zm5.5 14.949L15.949 17.5 12 13.551 8.051 17.5 6.5 15.949 10.449 12 6.5 8.051 8.051 6.5 12 10.449 15.949 6.5 17.5 8.051 13.551 12l3.949 3.949Z"
    />
  </svg>
);

export default CloseFilled;
